import { render, staticRenderFns } from "./BearingTypeList.vue?vue&type=template&id=770701eb&scoped=true&"
import script from "./BearingTypeList.vue?vue&type=script&lang=js&"
export * from "./BearingTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770701eb",
  null
  
)

export default component.exports